import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/common/card";

import { Content } from "@/components/layout/content";
import { Topbar } from "@/components/layout/topbar";
import { CreateActionForm } from "@/pages/admin/rules/actions/components/actions-create";
import { getRulesForSelect } from "@/pages/admin/rules/lib/queries";
import { getActionTypesForSelect } from "@/pages/admin/rules/actions/lib/queries";
import { useEffect, useState } from "react";

export default function ActionCreate() {
  const [rules, setRules] = useState([]);
  const [actiontypes, setActionTypes] = useState([]);

  const fetchRulesAndActionTypes = async () => {
    const [rules, actiontypes] = await Promise.all([
      getRulesForSelect(),
      getActionTypesForSelect(),
    ]);
    setRules(rules);
    setActionTypes(actiontypes);
  };

  useEffect(() => {
    fetchRulesAndActionTypes();
  }, []);

  return (
    <>
      <Topbar
        title="Toevoegen"
        breadcrumb={[{ title: "Actions", href: "/rules/actions" }]}
      />

      <Content>
        <Card>
          <CardHeader>
            <CardTitle>Basisinformatie</CardTitle>
          </CardHeader>
          <CardContent>
            <CreateActionForm rules={rules} actiontypes={actiontypes} />
          </CardContent>
        </Card>
      </Content>
    </>
  );
}
